module.exports = __webpack_public_path__ + "static/media/WZ8.79529c32.jpg";